import Transfer from '@/components/features/transfer/Transfer';
import i18n from '@/i18n/config';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const transferSearchSchema = z.object({
  project_id: z.string().optional(),
  is_active: z.boolean().optional(),
});

const TransferPage = () => {
  return <Transfer />;
};

export const Route = createFileRoute('/transfer/')({
  validateSearch: (search) => transferSearchSchema.parse(search),
  head: () => ({
    meta: [
      {
        title: `${i18n.t('transfer.title')} | Vehicle Console`,
      },
    ],
  }),
  component: TransferPage,
});
